__turbopack_context__.v({
  "config-skeleton": "loading-product-configuration-module-scss-module__QMceLW__config-skeleton",
  "image-container": "loading-product-configuration-module-scss-module__QMceLW__image-container",
  "order-details-skeleton": "loading-product-configuration-module-scss-module__QMceLW__order-details-skeleton",
  "section": "loading-product-configuration-module-scss-module__QMceLW__section",
  "skeleton-container": "loading-product-configuration-module-scss-module__QMceLW__skeleton-container",
});
